import React from 'react';
import { Modal, Form, Input, InputNumber } from 'antd';
import { FileAddOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';

export default function ModalCrear({ open, form, onOk, onCancel }) {
  return (
    <Modal
      title={<><FileAddOutlined /> Crear Reembolso</>}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText={<><SaveOutlined /> Crear</>}
      cancelText={<><CloseOutlined /> Cancelar</>}
      cancelButtonProps={{ danger: true }}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="asistenciaID" label="ID Asistencia" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="monto" label="Monto" rules={[{ required: true }]}>
          <InputNumber min={0.01} step={0.01} />
        </Form.Item>
        <Form.Item name="descripcion" label="Descripción" rules={[{ required: true }]}>
          <Input.TextArea rows={2} />
        </Form.Item>
        <Form.Item name="motivoReembolso" label="Motivo" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="nombreUsuario" label="Nombre usuario final" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="telefono" label="Teléfono usuario final" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
}